export const handleError = (error: any) => {
  if ('message' in error && error.message) {
    const message = error.message.replace('Error: ', '')
    alert(message)
  }
  console.error(error)
}
